import React from 'react';
import useIsInternational from '../../../../../Hooks/useIsInternational';
import { StoreProvider } from './FindInStoreContext';
import useIsMounted from './hooks/useIsMounted';
import StoreStatus from './StoreStatus';

export default function FindInStore({ currentAttributeState, contentData }) {
  const isInternational = useIsInternational();
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null;
  }

  if (isInternational) {
    return null;
  }

  return (
    <StoreProvider currentAttributeState={currentAttributeState} contentData={contentData}>
      <StoreStatus />
    </StoreProvider>
  );
}
